import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
var _refreshToken = /*#__PURE__*/_classPrivateFieldLooseKey("refreshToken");
class RefreshTokenCache {
  constructor() {
    Object.defineProperty(this, _refreshToken, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _refreshToken)[_refreshToken] = null;
  }
  get() {
    return _classPrivateFieldLooseBase(this, _refreshToken)[_refreshToken];
  }
  set(token) {
    if (typeof token !== 'string') {
      throw new Error(`Token is invalid. String expected, got ${typeof token}.`);
    }
    _classPrivateFieldLooseBase(this, _refreshToken)[_refreshToken] = token;
  }
  invalidate() {
    _classPrivateFieldLooseBase(this, _refreshToken)[_refreshToken] = null;
  }
}
export default RefreshTokenCache;
//# sourceMappingURL=RefreshTokenCache.js.map